import { EditableProps } from "@builder/components/editable/editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppSelector } from "@builder/store/store";
import { DynamicData } from "@common/build/dynamicData";
import { TextNode } from "@common/build/types";
import ImageFallback from "./ImageFallback";
import TextData from "./TextData";
import EditTime from "./EditTime";
import { DynamicImageElements } from "@builder/components/app/Popup/popups/DynamicData";

const DynamicDataOptions = ({ parent }: EditableProps) => {
    const selectedNode = useAppSelector(getSelectedNode) as TextNode;
    const isBuildSettingsKey = selectedNode?.dynamicData?.split(".")[0] === "buildSettingsKey";

    if (isBuildSettingsKey) {
        if (DynamicImageElements.includes(selectedNode?.name || "")) {
            return null;
        } else {
            return <TextData parent={parent} noFallback />;
        }
    }

    if (!selectedNode?.dynamicData) {
        return null;
    }

    const dynamicDataOptions = DynamicData[selectedNode.dynamicData]
    if (!dynamicDataOptions) {
        return null;
    }
    const dynamicDataType = dynamicDataOptions.dataType;

    return (
        <>
            {dynamicDataType != "image" && <TextData parent={parent} />}
            {dynamicDataType === "time" && <EditTime parent={parent} />}
            {dynamicDataType == "image" && <ImageFallback parent={parent} />}
        </>
    );
};

export default DynamicDataOptions;
